export default "__VITE_ASSET__4adff56c__"